import './VideoEmbed.css';

function VideoEmbed({ src, title }) {
  if (!src) return null;
  
  return (
    <div className="video-embed">
      <div className="video-container">
        <iframe
          src={src}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}

export default VideoEmbed;
